import { useEffect, useState, useCallback, useMemo } from 'react';

/* ═══════════════════════════════════════════════════════════════
   HOME — Índice de jornada SIMPLIFICADO
   Barra discreta de âncoras que aparece ao rolar (sem sidebar).
   Aponta para as seções-chave do guia embutido na home.
   ═══════════════════════════════════════════════════════════════ */

const ANCORAS = [
  { id: 'praias', label: 'Praias' },
  { id: 'como-chegar', label: 'Como chegar' },
  { id: 'quanto-custa', label: 'Custos' },
  { id: 'onde-ficar', label: 'Onde ficar' },
  { id: 'roteiros', label: 'Roteiros' },
  { id: 'faq', label: 'Dúvidas' },
] as const;

export function HomeJornadaNav() {
  const secoes = useMemo(() => ANCORAS, []);
  const [visivel, setVisivel] = useState(false);
  const [ativa, setAtiva] = useState<string>('');

  useEffect(() => {
    // só aparece depois de passar o hero (92vh), para não sobrepor o CTA do hero
    const onScroll = () => setVisivel(window.scrollY > window.innerHeight * 0.92);
    window.addEventListener('scroll', onScroll, { passive: true });

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(e => {
          if (e.isIntersecting) setAtiva(e.target.id);
        });
      },
      { rootMargin: '-45% 0px -50% 0px', threshold: 0 }
    );
    secoes.forEach(s => {
      const el = document.getElementById(s.id);
      if (el) observer.observe(el);
    });

    return () => {
      window.removeEventListener('scroll', onScroll);
      observer.disconnect();
    };
  }, [secoes]);

  const irPara = useCallback((id: string) => {
    const el = document.getElementById(id);
    if (!el) return;
    // compensa o header (64px) + esta barra, para a seção não ficar escondida
    const y = el.getBoundingClientRect().top + window.scrollY - 120;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }, []);

  return (
    <div
      className={`fixed top-16 left-0 right-0 z-30 transition-all duration-300 ${
        visivel ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-2 pointer-events-none'
      }`}
      aria-label="Índice da página"
    >
      <div className="mx-auto max-w-fit px-3">
        <div className="flex items-center gap-1 bg-white/95 backdrop-blur-sm border border-sand-200 rounded-full shadow-md px-2 py-1 overflow-x-auto no-scrollbar">
          <span className="hidden sm:inline font-body text-[11px] font-bold text-warm-gray/70 uppercase tracking-wider px-2 whitespace-nowrap">
            Nesta página
          </span>
          {secoes.map(s => (
            <button
              key={s.id}
              onClick={() => irPara(s.id)}
              className={`font-body text-xs px-3 py-1.5 rounded-full whitespace-nowrap transition-colors ${
                ativa === s.id
                  ? 'bg-teal-deep text-white font-semibold'
                  : 'text-warm-gray hover:bg-sand-50 hover:text-warm-dark'
              }`}
            >
              {s.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
